import React from "react";
import "./SuccessModal.css";

export const SuccessModal = ({ onClose }) => {
    return (
        <div className="success-popup-container">
            <div className="d-flex justify-content-between align-items-center">
                <span className="mb-0 sharetitle"></span>

                <span onClick={onClose} className="close-btn">
                    ✕
                </span>
            </div>
            <div className="success-content">
                <img className="success-check-icon" src="/assets/checkicon.svg" alt="Check Icon" />
                <p className="success-heading">Request Submitted Successfully!</p>
                <span className="success-desc">We've received your request, and our team will get back to you shortly.</span>
            </div>

        </div>
    )
}